import i18n from "./index";

/**
 * Bound to the active language, not `nl-NL`: a hardcoded locale is a translation hiding in a
 * formatter. Cached per locale, because `Intl.DateTimeFormat` is expensive and these run per row.
 */
const cache = new Map<string, Intl.DateTimeFormat>();

function formatter(name: string, options: Intl.DateTimeFormatOptions) {
  const key = `${i18n.language}:${name}`;
  let found = cache.get(key);
  if (!found) {
    found = new Intl.DateTimeFormat(i18n.language, options);
    cache.set(key, found);
  }
  return found;
}

const toDate = (value: Date | string) => (value instanceof Date ? value : new Date(value));

/** A deadline: "1 maart 2027 17:00". */
export const moment = (value: Date | string) =>
  formatter("moment", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(toDate(value));

/** A wedstrijddag named in full: "zaterdag 12 juni 2027". */
export const datumLang = (value: Date | string) =>
  formatter("lang", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(toDate(value));

/** A date in a table cell, where the row already carries the year: "12 jun". */
export const datumKort = (value: Date | string) =>
  formatter("kort", { day: "numeric", month: "short" }).format(toDate(value));
